import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import BaseModal from 'components/UI/Modal/BaseModal';
import Button from 'components/UI/V3/Button/Button';
import { EmailTemplate } from '../types';
import { templateCategoryLabel } from '../utils';
import { EmailPreview } from '../UI/EmailPreview/EmailPreview';
import styles from './TemplatePreviewModal.module.scss';

interface TemplatePreviewModalProps {
    template: EmailTemplate;
    locationName?: string;
    useLabel?: string;
    onClose: () => void;
    onUse?: () => void;
}

export const TemplatePreviewModal: React.FC<TemplatePreviewModalProps> = ({
    template,
    locationName,
    useLabel = 'Use in campaign',
    onClose,
    onUse
}) => (
    <BaseModal
        isOpen
        onClose={onClose}
    >
        <BaseModal.Header showDefaultLayout={false}>
            <div className={styles.header}>
                <div className={styles.titles}>
                    <h2 className={styles.title}>{template.name}</h2>
                    <span className={styles.meta}>
                        {template.source === 'location'
                            ? locationName
                            : `Cuddles gallery · ${templateCategoryLabel(template.category)}`}
                    </span>
                </div>
                <div className={styles.actions}>
                    {onUse && (
                        <Button
                            variant="black"
                            label={useLabel}
                            onClick={onUse}
                        />
                    )}
                    <button
                        type="button"
                        aria-label="Close"
                        className={styles.close}
                        onClick={onClose}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
            </div>
        </BaseModal.Header>

        <div className={styles.body}>
            <EmailPreview
                html={template.html}
                fromName={locationName || 'Your location'}
                subject={template.subjectDefault}
            />
        </div>
    </BaseModal>
);

export default TemplatePreviewModal;
